import { MsalService } from '@azure/msal-angular';
import { msalInstance } from './msal-config';

export function initializeMsal(msalService: MsalService): () => Promise<void> {
  return async () => {
    await msalInstance.initialize();

    const result = await msalService.instance.handleRedirectPromise();

    if (result?.account) {
      msalService.instance.setActiveAccount(result.account);
    } else {
      const accounts = msalService.instance.getAllAccounts();
      if (accounts.length > 0) {
        msalService.instance.setActiveAccount(accounts[0]);
      }
    }
  };
}

